import { createTheme, ITheme } from "@fluentui/react";

// Define your custom colors and styles
const customTheme: ITheme = createTheme({
 palette: {
    themePrimary: '#004a88',
    themeLighterAlt: '#f0f6fa',
    themeLighter: '#c6dbec',
    themeLight: '#99bddb',
    themeTertiary: '#4986b7',
    themeSecondary: '#125a96',
    themeDarkAlt: '#00437a',
    themeDark: '#003867',
    themeDarker: '#002a4c',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralSecondaryAlt: '#8a8886',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
  }
});

export default customTheme;